import { render, staticRenderFns } from "./ProInfo1Show.vue?vue&type=template&id=7f5b3dec&scoped=true"
import script from "./ProInfo1Show.vue?vue&type=script&lang=js"
export * from "./ProInfo1Show.vue?vue&type=script&lang=js"
import style0 from "./ProInfo1Show.vue?vue&type=style&index=0&id=7f5b3dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5b3dec",
  null
  
)

export default component.exports